export default "__VITE_ASSET__0uIjE4HT__"